export default __webpack_public_path__ + "static/media/logo-dark.4efff1a5.png";